/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9348b4de (Tue Jan 13 18:25:19 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface EditBusinessEmailRequestBody
 */
export interface EditBusinessEmailRequestBody {
  /**
   * The new business email address, which must not be a Classical Conversations email address.
   * @type string
   * @memberof EditBusinessEmailRequestBody
   */
  businessEmail?: string
}

export function EditBusinessEmailRequestBodyFromJSON(
  json: any
): EditBusinessEmailRequestBody {
  return EditBusinessEmailRequestBodyFromJSONTyped(json, false)
}

export function EditBusinessEmailRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EditBusinessEmailRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    businessEmail: !exists(json, 'businessEmail')
      ? undefined
      : json['businessEmail'],
  }
}

export function EditBusinessEmailRequestBodyToJSON(
  value?: EditBusinessEmailRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    businessEmail: value.businessEmail,
  }
}
